import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=6e9fe5d5&scoped=true&"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9fe5d5",
  null
  
)

export default component.exports